
	export default class Api{
	constructor(){
		// event handling
		this.updateUser_handlers = [];
	}

	async payAsync(sum, provider){
		return await fetch("/balance/pay", {
			body:"Sum="+sum+"&Provider="+provider, method:"POST", headers:{"Content-Type":"application/x-www-form-urlencoded"}
		}).then(f=>f.json());
	}
	pay = (sum, provider, callback) => this.payAsync(sum, provider).then(c=>callback(c));

	async withdrawAsync(qiwi, sum){
		return await fetch("/api/withdraw", {
			body:JSON.stringify({Qiwi:qiwi, Sum:sum}), method:"POST", headers:{"Content-Type":"application/json"}
		}).then(f=>f.json());
	}
	withdraw = (qiwi, sum, callback) => this.withdrawAsync(qiwi, sum).then(c=>callback(c));
	
	async logInAsync(login, password){
		return await fetch("/api/login", {
			body:JSON.stringify({Login:login, Password:password}),
			headers:{"Content-Type":"application/json"},
			method:"POST"
		}).then(r=>r.json());
	}
	logIn(login, password, callback){
		this.logInAsync(login, password).then(c=>callback(c));
	}

	async registerAsync(login, password, email){
		return await fetch("/api/register", {
			body:JSON.stringify({Login:login, Password:password, Email:email}),
			headers:{"Content-Type":"application/json"},
			method:"POST"
		}).then(r=>r.json());
	}
	register(login, password, email, callback){
		this.registerAsync(login, password, email).then(c=>callback(c));
	}

	async getUserAsync(){
		var user = await fetch("/api/user").then(u=>u.json());
			user.logOut = ()=>this.logOut();
			user.updateUser_subscribe = (handler)=>this.updateUser_handlers.push(handler);
			return user;
		
	}

	getUser(callback){
		this.getUserAsync().then(c=>callback(c));
	}

	async getGamesAsync(){
		return await fetch("/api/games").then(f=>f.json());
	}

	getGames(callback){
		this.getGamesAsync().then(c=>c&&callback(c));
	}

	async getProductsAsync(filters, skip = 0, take = 50){
		/*export let filter = {
		game: 1, category: 0,
		search: "",
		priceMin: -1, priceMax: -1,
		sellerVerified: false, sellerNotVerified: false
	};*/
		if (!filters) filters = {};
		let apiFilters = {
			Game:filters.game, Category:filters.category,
			Search:filters.search, PriceMin:filters.priceMin,
			PriceMax:filters.priceMax,SellerVerified:filters.sellerVerified,SellerNotVerified:filters.sellerNotVerified,
			Sort:filters.sort, Skip:skip, Take:take
		}
		return await fetch("/api/products", {
			body: JSON.stringify(apiFilters),
			method:"POST",
			headers:{"Content-Type":"application/json"}
		}).then(f=>f.json());
			
	}

	getProducts(filters, callback, skip = 0, take = 50){
		this.getProductsAsync(filters, skip, take).then(p=>callback(p));
	}

	async getCategoryAsync(game){
		return await fetch("/api/games/"+game+"/categories").then(f=>f.json());
	}

	getCategory(game, callback){
		this.getCategoryAsync(game).then(function (c){
			if (c) callback(c);
		});
	}

	async logOutAsync(){
		await fetch("/api/logout").then(f=>f.json());
		await this.refreshUserAsync();
	}
	logOut(callback){
		this.logOutAsync().then(c=>callback());
	}
	
	async refreshUserAsync(){
		let user = await this.getUserAsync();
		console.log(user);
		this.updateUser_handlers.forEach(h=>h(user));
	}
	refreshUser(callback){
		this.refreshUserAsync().then(c=>callback());
	}
}